import { createReducer, on, Action } from '@ngrx/store';
import { ToolTrackerActions } from './tool-tracker.action';
import { ToolTrackerState } from './tool-tracker.state';

const reducer = createReducer(
  ToolTrackerState.initialState,
  on(ToolTrackerActions.loadContainersSuccess, (state, action) => ({
    ...state,
    loadedContainers: action.containers.reduce(
      (dict, entry) => ({ ...dict, [entry.containerId]: entry }),
      state.loadedContainers
    ),
  })),
  on(ToolTrackerActions.selectContainer, (state, action) => ({
    ...state,
    selectedContainerId: action.container && action.container.containerId,
  })),
  on(ToolTrackerActions.loadContainersSuccess, (state, action) => ({
    ...state,
    loadedContainers: action.containers.reduce(
      (dict, entry) => ({ ...dict, [entry.containerId]: entry }),
      state.loadedContainers
    ),
    containerCount:
      action.count ??
      Object.values(state.loadedContainers).length + action.containers.length,
  })),
  on(ToolTrackerActions.selectContainer, (state, action) => ({
    ...state,
    selectedContainerId: action.container && action.container.containerId,
  }))
);

export function toolTrackerReducer(
  state: ToolTrackerState.IState | undefined,
  action: Action
) {
  return reducer(state, action);
}
